var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { useCallback, useEffect, useState } from "react";
import axios from "axios";
import { Chains, getSubgraphURIForVersion, SUBGRAPHS_TO_QUERY, VaultVersionList, } from "../constants/constants";
import { defaultVaultSubgraphData, } from "./subgraphDataContext";
import { impersonateAddress } from "../utils/development";
import { resolveVaultAccountsSubgraphResponse, vaultAccountsGraphql, } from "./useVaultAccounts";
import { isProduction } from "../utils/env";
import { resolveTransactionsSubgraphResponse, transactionsGraphql, } from "./useTransactions";
import { balancesGraphql, resolveBalancesSubgraphResponse, } from "./useBalances";
import { resolveVaultActivitiesSubgraphResponse, vaultActivitiesGraphql, } from "./useVaultActivity";
import { vaultPriceHistoryGraphql, resolveVaultPriceHistorySubgraphResponse, } from "./useVaultPerformanceUpdate";
import { usePendingTransactions } from "./pendingTransactionsContext";
import { resolveVaultsSubgraphResponse, vaultGraphql } from "./useVaultData";
import { liquidityMiningPoolGraphql, resolveLiquidityMiningPoolsSubgraphResponse, } from "./useLiquidityMiningPools";
import { liquidityMiningPoolAccountsGraphql, resolveLiquidityMiningPoolAccountsSubgraphResponse, } from "./useLiquidityMiningPoolAccounts";
import useWeb3Wallet from "./useWeb3Wallet";
var useFetchVaultSubgraphData = function () {
    var acc = useWeb3Wallet().account;
    var account = impersonateAddress || acc;
    var _a = useState(defaultVaultSubgraphData), data = _a[0], setData = _a[1];
    var transactionsCounter = usePendingTransactions().transactionsCounter;
    var _b = useState(0), setMulticallCounter = _b[1];
    var doMulticall = useCallback(function () { return __awaiter(void 0, void 0, void 0, function () {
        var currentCounter, allSubgraphResponses, responsesAcrossVersions;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (!isProduction()) {
                        console.time("Subgraph Data Fetch"); // eslint-disable-line
                    }
                    setMulticallCounter(function (counter) {
                        currentCounter = counter + 1;
                        setData(function (prev) { return (__assign(__assign({}, prev), { loading: true })); });
                        return currentCounter;
                    });
                    return [4 /*yield*/, Promise.all(SUBGRAPHS_TO_QUERY.map(function (_a) {
                            var version = _a[0], chain = _a[1];
                            return __awaiter(void 0, void 0, void 0, function () {
                                var query_1, response_1, query, response;
                                return __generator(this, function (_b) {
                                    switch (_b.label) {
                                        case 0:
                                            if (!(version === "earn")) return [3 /*break*/, 2];
                                            query_1 = ((chain === Chains.Solana ? "query" : "") + " {\n            " + (account
                                                ? "\n                    " + vaultAccountsGraphql(account, version) + "\n                    " + transactionsGraphql(account, chain) + "\n                    " + balancesGraphql(account, chain) + "\n                  "
                                                : "") + "\n            " + vaultGraphql(version, chain) + "\n            " + vaultActivitiesGraphql(version, chain) + "\n            " + vaultPriceHistoryGraphql(version, chain) + "\n          }").replaceAll(" ", "");
                                            return [4 /*yield*/, axios.post(getSubgraphURIForVersion(version, chain), {
                                                    query: query_1,
                                                })];
                                        case 1:
                                            response_1 = _b.sent();
                                            return [2 /*return*/, [version, response_1.data.data]];
                                        case 2:
                                            query = ((chain === Chains.Solana ? "query" : "") + " {\n          " + (account
                                                ? "\n                  " + vaultAccountsGraphql(account, version) + "\n                  " + transactionsGraphql(account, chain) + "\n                  " + balancesGraphql(account, chain) + "\n                  " + liquidityMiningPoolAccountsGraphql(account, version) + "\n                "
                                                : "") + "\n          " + vaultGraphql(version, chain) + "\n          " + vaultActivitiesGraphql(version, chain) + "\n          " + vaultPriceHistoryGraphql(version, chain) + "\n          " + liquidityMiningPoolGraphql(version, chain) + "\n        }").replaceAll(" ", "");
                                            return [4 /*yield*/, axios.post(getSubgraphURIForVersion(version, chain), {
                                                    query: query,
                                                })];
                                        case 3:
                                            response = _b.sent();
                                            return [2 /*return*/, [version, response.data.data]];
                                    }
                                });
                            });
                        }))];
                case 1:
                    allSubgraphResponses = _a.sent();
                    responsesAcrossVersions = Object.fromEntries(VaultVersionList.map(function (version) {
                        var mergedResponse = {};
                        var responsesForVersion = allSubgraphResponses
                            .filter(function (_a) {
                            var resVersion = _a[0], _ = _a[1];
                            return resVersion === version;
                        })
                            .map(function (_a) {
                            var _ = _a[0], res = _a[1];
                            return res;
                        });
                        responsesForVersion.forEach(function (response) {
                            if (response) {
                                Object.keys(response).forEach(function (key) {
                                    var _a;
                                    // Push response if its an array
                                    // Otherwise merge without overriding existing property
                                    if (!mergedResponse[key]) {
                                        mergedResponse[key] = response[key];
                                    }
                                    else if (Array.isArray(mergedResponse[key]) &&
                                        Array.isArray(response[key])) {
                                        (_a = mergedResponse[key]).push.apply(_a, response[key]);
                                    }
                                });
                            }
                        });
                        return [version, mergedResponse];
                    }));
                    setMulticallCounter(function (counter) {
                        if (counter === currentCounter) {
                            setData(function (prev) { return (__assign(__assign({}, prev), { vaults: resolveVaultsSubgraphResponse(responsesAcrossVersions), vaultAccounts: resolveVaultAccountsSubgraphResponse(responsesAcrossVersions), vaultActivities: resolveVaultActivitiesSubgraphResponse(responsesAcrossVersions), balances: resolveBalancesSubgraphResponse(responsesAcrossVersions), transactions: resolveTransactionsSubgraphResponse(responsesAcrossVersions), vaultPriceHistory: resolveVaultPriceHistorySubgraphResponse(responsesAcrossVersions), stakingPools: {
                                    lm: resolveLiquidityMiningPoolsSubgraphResponse(responsesAcrossVersions),
                                }, stakingAccounts: {
                                    lm: resolveLiquidityMiningPoolAccountsSubgraphResponse(responsesAcrossVersions),
                                }, loading: false })); });
                        }
                        return counter;
                    });
                    if (!isProduction()) {
                        console.timeEnd("Subgraph Data Fetch"); // eslint-disable-line
                    }
                    return [2 /*return*/];
            }
        });
    }); }, [account]);
    useEffect(function () {
        doMulticall();
    }, [doMulticall, transactionsCounter]);
    return data;
};
export default useFetchVaultSubgraphData;
//# sourceMappingURL=useFetchVaultSubgraphData.js.map